/*
 * Public API Surface of ng-circle-progress
 */

export * from './lib/ng-circle-progress.component';
export * from './lib/ng-circle-progress.module';
